(function () {
  function init(root) {
    if (!root || root.dataset.gsBound) return;
    root.dataset.gsBound = 'true';

    var label = root.querySelector('.form__label__value');
    if (!label) return;

    var selected = label.textContent.trim();

    root.querySelectorAll('.gs-siblings__swatch').forEach(function (swatch) {
      var colour = swatch.dataset.colour;
      if (!colour) return;

      swatch.addEventListener('mouseenter', function () {
        label.textContent = colour;
      });

      swatch.addEventListener('focus', function () {
        label.textContent = colour;
      });
    });

    root.addEventListener('mouseleave', function () {
      label.textContent = selected;
    });

    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) label.textContent = selected;
    });
  }

  function boot() {
    document.querySelectorAll('.gs-siblings').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();